<template>
  <PageView :main-title="title" :sub-title="subtitle" :display-sub-title-in-green="true">
    <ContentView>
      <h1 class="title">{{ $t("IndicateursPage.title") }}</h1>

      <IndicateursView v-if="grae" :grae="grae" :annee-scolaire="selectedAnneeScolaire" />
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { eventBus } from "@/services/EventBus"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import IndicateursView from "./IndicateursView.vue"

import { GraeDTO, GraeStatsDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { LoginService } from "@/services/rest/login/LoginService"
import { UsersService } from "@/services/rest/users/UsersService"
import { OrganismeService } from "@/services/rest/organisme/OrganismeService"
import { BackToPreviousScreenItem, ContextMenu } from "@/views/menus/MenuItems"

export default defineComponent({
  name: "IndicateursPage",
  components: {
    PageView,
    ContentView,
    IndicateursView,
  },
  props: {
    graeId: {
      type: String,
      required: false,
    },
  },

  emits: ["contextual-menu-changed"],
  data() {
    return {
      brouillonFilters: JSON.stringify([
        { property: "typeDossier", values: ["DOSSIER_INSCRIPTION"] },
        { property: "statut", values: ["BROUILLON"] },
      ]),

      loginService: LoginService.INSTANCE,
      usersService: UsersService.INSTANCE,
      organismeService: OrganismeService.INSTANCE,
      user: new UtilisateurDTO(),
      grae: new GraeDTO(),
      graeStats: new GraeStatsDTO(),
      contact: new UtilisateurDTO(),
      title: "",
      subtitle: this.$t("indicateursPage.title"),
      dasharray: "100 0",
      selectedAnneeScolaire: "",
    }
  },
  async created(): Promise<void> {
    const loggedUser = this.loginService.getLoggedUser()

    if (!loggedUser || !loggedUser.id) {
      return
    }
    if (!this.graeId) {
      await this.getGraeFromLoggedUser(loggedUser.id)
    } else {
      await this.getGraeFromId(loggedUser.id, this.graeId)
    }
  },
  methods: {
    async getGraeFromLoggedUser(id: string): Promise<void> {
      this.user = await this.usersService.getUserProfile(id)
      if (this.user && this.user.grae) {
        this.grae = this.user.grae as GraeDTO
      }
      this.refreshContextMenu(false)
      this.title = this.$t("indicateursPage.subTitle").toString() + this.grae.region
    },

    async getGraeFromId(loggedUserId: string, graedId: string): Promise<void> {
      this.user = await this.usersService.getUserProfile(loggedUserId)
      this.grae = await this.organismeService.getGrae(graedId)
      const isFromGrae = this.user.grae?.id == this.grae.id
      this.refreshContextMenu(!isFromGrae)
      this.title = this.$t("indicateursPage.subTitle").toString() + this.grae.region
    },

    refreshContextMenu(showBackToListMenuEntry: boolean): void {
      const menuItems = []
      if (this.grae) {
        //const graeId = this.grae.id
        // Back to previous screen (if comming from list)
        if (showBackToListMenuEntry) {
          menuItems.push(new BackToPreviousScreenItem())
        }

        const possibleMenuParents = ["/grae-list", "/grae/details/"]
        eventBus.emit("contextual-menu-changed", new ContextMenu(possibleMenuParents, menuItems))
      }
    },
  },
})
</script>
